export default "__VITE_ASSET__CIQvv47C__"